module.exports = __webpack_public_path__ + "media/images/element/help-edbff59e9e9ca9440ff54c4c4602157c.svg";